import React from "react";

function Description_About_Product_Forms_edit() {
  return (
    <div className="p-5 border-2 border-gray-200 rounded-xl ">
      {/* Title */}
      <div className="border-b pb-2">
        <p className="text-lg font-semibold text-gray-700">
          Description About Product
        </p>
      </div>

      {/* Product Description */}
      <div className="mt-4">
        <p className="text-md font-medium text-gray-700">
          Product Description :
        </p>
        <p className="mt-2 mb-5 text-sm px-10 text-gray-600 leading-relaxed">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris.
        </p>
        <hr />
      </div>

      {/* Product Variants */}
      <div className="mt-4">
        <p className="text-md   font-medium text-gray-700">
          Product Variants :
        </p>
        <p className="mt-2 mb-5 text-sm px-10 text-gray-600 leading-relaxed">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris.
        </p>
        <hr />
      </div>

      {/* Product Certification */}
      <div className="my-4">
        <p className="text-md font-medium text-gray-700">
          Product Certification :
        </p>
        <div className="mt-2 flex px-10 justify-center flex-wrap gap-2">
          {Array(10)
            .fill("Best Quality")
            .map((label, index) => (
              <button
                key={index} 
                className="px-4 py-2 border border-gray-300 bg-gray-300 rounded-md text-sm text-gray-600 uppercase hover:bg-gray-100 transition-colors"
              >
                {label}
              </button>
            ))}
        </div>
      </div>
      <hr />
    </div>
  );
}

export default Description_About_Product_Forms_edit;
